'use client';

import { SetUpAutoshipImmediateTitle } from '@libs/shared-ui';

import { useProduct } from '@/entities/product';
import { usePurchaseFormWatch } from '@/entities/purchase-form';

export const ImmediateDeliveryTitle = () => {
    const { product, tailored } = useProduct();

    const deliveryMethod = usePurchaseFormWatch('fulfilmentMethod');

    const storeId = tailored?.variants?.[product?.sku ?? '']?.BOPIS?.storeId;
    const store = tailored?.bopisStoreData?.[storeId ?? '']?.storeDetails;

    return <SetUpAutoshipImmediateTitle fulfillmentMethod={deliveryMethod ?? 'bopis'} storeName={store?.name} />;
};
